// eslint-disable-next-line import/prefer-default-export
export var ERROR_MESSAGES = {
  invalidTime: "Invalid time provided",
  timeIncludesLetters: "Time cannot include letters",
  timeDisabled: "Time is disabled"
};